export const baseURL = "https://redchat.leoitservices.in/";
export const secretKey = "your_secret_key";
export const  projectName = "redchat";
